const regexTpl = /\.\/(.+)\.tpl/;

const _ = require('lodash');
const template = require('lodash/template');

const settings = {
  interpolate: /\{NOESCAPE\{(.+?)\}\}/g,
  escape: /\{\{(.+?)\}\}/g,
  evaluate: /\<\?(.+?)\?\>/g,
  imports: {
    '_': _
  }
};

// HACK!
// 
// We can't pre-compile these templates with a call to `_.template`
// this is because it uses the `with obj` syntax which is not allowed in
// 'use strict' mode
//
const makeLazyTemplate = function(strn) {
  var precompiledTemplate;
  return function(data) {
    if (!precompiledTemplate) {
      precompiledTemplate = template(strn, settings);
    }
    return precompiledTemplate(data);
  };
};


function requireAllAsJst(JST_OBJ, availableRequires) { 
  // console.log(availableRequires.keys());
  // r.keys().forEach(r);

  availableRequires.keys().forEach(function(fileBase) {
    let matched = fileBase.match(regexTpl);
    if (matched && matched.length == 2) {
      let name = matched[1];
      JST_OBJ[name] = makeLazyTemplate(
        availableRequires(fileBase) // This must be a raw string from a tpl file!
      ); 
    }
  });

} 

module.exports = {
  requireAllAsJst: requireAllAsJst,
  makeLazyTemplate: makeLazyTemplate
};